import { styled } from '@mui/material';

export const Image = styled('img')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  display: 'block',
  flexShrink: 0,
  height: '30px',
  marginRight: theme.spacing(1),
  objectFit: 'contain',
  objectPosition: 'center',
  padding: theme.spacing(0.5),
  width: '30px',
}));
